const state = {
  // 初始讀取狀態
  initialLoading: true,
  // 推薦檔次讀取狀態
  crmLoaded: true,
  // 頂部Banners
  eventBanners: [
  ],
  // 策展小圖入口
  curationList: [
    {
      title: "",
      link: "#",
      pic: ""
    },
    {
      title: "",
      link: "#",
      pic: ""
    },
    {
      title: "",
      link: "#",
      pic: ""
    },
    {
      title: "",
      link: "#",
      pic: ""
    },
    {
      title: "",
      link: "#",
      pic: ""
    },
    {
      title: "",
      link: "#",
      pic: ""
    },
    {
      title: "",
      link: "#",
      pic: ""
    },
    {
      title: "",
      link: "#",
      pic: ""
    }
  ],
  // 熱門商品內容
  topSale: [
    {
      title: "",
      subtitle: "",
      link: "#",
      img: "",
      price: "",
      origin: "",
      people: ""
    },
    {
      title: "",
      subtitle: "",
      link: "#",
      img: "",
      price: "",
      origin: "",
      people: ""
    },
    {
      title: "",
      subtitle: "",
      link: "#",
      img: "",
      price: "",
      origin: "",
      people: ""
    },
    {
      title: "",
      subtitle: "",
      link: "#",
      img: "",
      price: "",
      origin: "",
      people: ""
    },
  ],
  // 策展商品內容
  curationEvents:[
    {
      banner: {
        link: process.env.VUE_APP_API_BASE_URL,
        pic: "",
        title: ""
      },
      deals:[
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
      ]
    }
  ],
  // 一般商品策展
  normalEvents: [
    {
      banner:{
        title:"",
        link:"",
        pic:""
      },
      deals:[
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
        {
          title: "",
          subtitle: "",
          link: "#",
          img: "",
          price: "",
          origin: "",
          people: ""
        },
      ]
    },
  ],
  // 推薦商品內容
  crmProducts: [
    {
      "id": "007",
      "title": "・・・",
      "subTitle": "",
      "img": "",
      "imgAlt": "",
      "sqImg": "",
      "url": "007",
      "soldOut": false,
      "promoImg": "",
      "salesVolume": "???",
      "origPrice": "???",
      "price": "???",
      "discountPrice": "???",
      "priceTail": "起",
      "discount": "?折",
      "icons": [
          {
              "title": "折價",
              "style": 11
          },
      ],
      "rating": {
          "show": false,
          "number": 0,
          "score": 0
      },
      "inCollect": false
    },
    {
      "id": "007",
      "title": "・・・",
      "subTitle": "",
      "img": "",
      "imgAlt": "",
      "sqImg": "",
      "url": "007",
      "soldOut": false,
      "promoImg": "",
      "salesVolume": "???",
      "origPrice": "???",
      "price": "???",
      "discountPrice": "???",
      "priceTail": "起",
      "discount": "?折",
      "icons": [
          {
              "title": "折價",
              "style": 11
          },
      ],
      "rating": {
          "show": false,
          "number": 0,
          "score": 0
      },
      "inCollect": false
    },
  ],
  // 側邊欄頻道號碼
  categoryInitialNumber: null,
  // 側邊欄標題
  categoryTabs:[
  ],
  // 側邊欄標題 - 連結
  categoryTabsLinks:[
  ],
  // 側邊欄內容
  categoryContent:{
    classfyBanner1:{
      id: 0,
      imageHtml: ""
    },
    classfyBanner2:{
      id: 0,
      imageHtml: ""
    },
    category:[
      {
        id: 0,
        name: "...",
        imagePath: "",
        link: "#"
      },
      {
        id: 0,
        name: "...",
        imagePath: "",
        link: "#"
      },
    ],
    link:null
  },
  // 蓋板廣告置放
  overlayAds:{
  },
  // 會員登入狀態
  memberInfo:{
    isAuthenticated: false,
    name: "",
    displayName: "",
    pic: ""
  },
  // 收藏列表暫存區
  collectSuccess: 0,
  // 蓋板廣告預設值
  overlayAdsAvailable: false,
  overlayAdsCountdown: 5,
}

export default {
  state
}